export default __webpack_public_path__ + "static/media/abbeville5.dfbf0c65.jpg";